module.exports = __webpack_public_path__ + "img/joy_07.9dcd386f.png";